module.exports = __webpack_public_path__ + "static/img/question6-4.2d8410b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question6-4.png
// module id = dbIW
// module chunks = 1